import bookCreatorProvider from "@/core/providers/book-creator";
import { uploadPDF } from "@/core/requests/book-creator";
import { toastSuccess } from "@/core/utils/notification";
import { BookOpenIcon, CubeTransparentIcon, PaperAirplaneIcon, PlusIcon, QuestionMarkCircleIcon } from "@heroicons/react/24/outline";
import { FC, ReactNode, useState } from "react";
import { Sheet } from "react-modal-sheet";
import CreatePageSheetWrapper from "./page-create-panel-wrapper";
import IconButton from "../common/icon-button";
const ThumbnailToolBar = () => {
    return <div className="w-16 border-l border-gray-50 flex justify-center p-2 ">
        <div className="p-2 border-border bg-background dark:bg-dark-background border rounded-md">
            <CreatePageSheetWrapper>
                <div className="rounded bg-background cursor-pointer hover:bg-gray-300  w-8 h-8 flex justify-center items-center">
                    <PlusIcon className="size-4 stroke-text"/>
                </div>
            </CreatePageSheetWrapper>
        </div>
    </div >
}

// const Button = () => {
//     return <CreatePageSheetWrapper>
//         <button onClick={() => {
//             // toastSuccess("测试");
//         }} className="rounded bg-gray-200 hover:bg-gray-300  w-8 h-8 flex justify-center items-center">
//             <PlusIcon className="size-8 stroke-dark-text" />
//         </button>

// }


export default ThumbnailToolBar;